export const translationNotFound_sv = {
  notFoundTitle: "Sidan hittades inte",
  notFoundDescription:
    "Länken kan ha ändrats eller gått ut. Använd navigeringen eller återgå till dashboardens startsida.",
  notFoundHomeLink: "Gå till dashboardens startsida",
};
